// extracted by mini-css-extract-plugin
export default {"links":"ContentLinks_links__URHNO","link":"ContentLinks_link__BVeKO","active":"ContentLinks_active__jrS8q"};